import React, {useState, useMemo} from 'react';
import { Button, TextField} from '@mui/material';
import { API_OK, API_EXCEPTION, DEFAULT_ERROR_TEXT } from '../Constants';
import cookie from "js-cookie";
import axios from "axios";
import '../styles.css';
import { useTranslation } from 'react-i18next';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../features/user";
import {handleApiErrorMessage} from "../Helper";
import { showErrorDialog } from "../features/errorDialog";
import countryList from 'react-select-country-list';

/* ISO alpha-2 → international dialing code */
const DIAL_CODES = {
  AD:'376',AE:'971',AF:'93',AG:'1268',AI:'1264',AL:'355',AM:'374',AO:'244',AR:'54',AS:'1684',AT:'43',AU:'61',AW:'297',AX:'358',AZ:'994',
  BA:'387',BB:'1246',BD:'880',BE:'32',BF:'226',BG:'359',BH:'973',BI:'257',BJ:'229',BL:'590',BM:'1441',BN:'673',BO:'591',BQ:'599',BR:'55',BS:'1242',BT:'975',BW:'267',BY:'375',BZ:'501',
  CA:'1',CC:'61',CD:'243',CF:'236',CG:'242',CH:'41',CI:'225',CK:'682',CL:'56',CM:'237',CN:'86',CO:'57',CR:'506',CU:'53',CV:'238',CW:'599',CX:'61',CY:'357',CZ:'420',
  DE:'49',DJ:'253',DK:'45',DM:'1767',DO:'1809',DZ:'213',EC:'593',EE:'372',EG:'20',EH:'212',ER:'291',ES:'34',ET:'251',
  FI:'358',FJ:'679',FK:'500',FM:'691',FO:'298',FR:'33',GA:'241',GB:'44',GD:'1473',GE:'995',GF:'594',GG:'44',GH:'233',GI:'350',GL:'299',GM:'220',GN:'224',GP:'590',GQ:'240',GR:'30',GT:'502',GU:'1671',GW:'245',GY:'592',
  HK:'852',HN:'504',HR:'385',HT:'509',HU:'36',ID:'62',IE:'353',IL:'972',IM:'44',IN:'91',IO:'246',IQ:'964',IR:'98',IS:'354',IT:'39',
  JE:'44',JM:'1876',JO:'962',JP:'81',KE:'254',KG:'996',KH:'855',KI:'686',KM:'269',KN:'1869',KP:'850',KR:'82',KW:'965',KY:'1345',KZ:'7',
  LA:'856',LB:'961',LC:'1758',LI:'423',LK:'94',LR:'231',LS:'266',LT:'370',LU:'352',LV:'371',LY:'218',
  MA:'212',MC:'377',MD:'373',ME:'382',MF:'590',MG:'261',MH:'692',MK:'389',ML:'223',MM:'95',MN:'976',MO:'853',MP:'1670',MQ:'596',MR:'222',MS:'1664',MT:'356',MU:'230',MV:'960',MW:'265',MX:'52',MY:'60',MZ:'258',
  NA:'264',NC:'687',NE:'227',NF:'672',NG:'234',NI:'505',NL:'31',NO:'47',NP:'977',NR:'674',NU:'683',NZ:'64',OM:'968',
  PA:'507',PE:'51',PF:'689',PG:'675',PH:'63',PK:'92',PL:'48',PM:'508',PN:'64',PR:'1787',PS:'970',PT:'351',PW:'680',PY:'595',QA:'974',RE:'262',RO:'40',RS:'381',RU:'7',RW:'250',
  SA:'966',SB:'677',SC:'248',SD:'249',SE:'46',SG:'65',SH:'290',SI:'386',SJ:'47',SK:'421',SL:'232',SM:'378',SN:'221',SO:'252',SR:'597',SS:'211',ST:'239',SV:'503',SX:'1721',SY:'963',SZ:'268',
  TC:'1649',TD:'235',TF:'262',TG:'228',TH:'66',TJ:'992',TK:'690',TL:'670',TM:'993',TN:'216',TO:'676',TR:'90',TT:'1868',TV:'688',TW:'886',TZ:'255',
  UA:'380',UG:'256',US:'1',UY:'598',UZ:'998',VA:'39',VC:'1784',VE:'58',VG:'1284',VI:'1340',VN:'84',VU:'678',WF:'681',WS:'685',YE:'967',YT:'262',ZA:'27',ZM:'260',ZW:'263'
};

export default function SendNumber(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const countryOptions = useMemo(() => countryList().getValues(), []);
  
  const [addNumber, setAddNumber] = useState('');
  const [addNumbers, setAddNumbers] = useState([]);
  const [addNumberComment, setAddNumberComment] = useState('');
  const [countryCode, setCountryCode] = useState('IL');

  const handleSetNumber = (inputValue) => {
    let numericValue = inputValue.replace(/[^\+\d]/g,'');
    setAddNumber(numericValue);
  }

  const handleSetNumbers = (inputValue) => {
    const numberLines = inputValue.split(/\r?\n/);

    let numberLinesFixed = [];
    let numericValue = null;

    for(let i=0; i<numberLines.length; i++){
      numericValue = numberLines[i].replace(/[^\+\d]/g,'');
      numberLinesFixed.push(numericValue);
    }
    setAddNumbers(numberLinesFixed);
  }

  const handleSubmitReportNumber = () => {
    if(props.isMany === true){
      if(addNumbers.length === 0){
        return;
      }
    }else{
      if(addNumber === ""){
        return;
      }
    }

    let errorMessage = t(DEFAULT_ERROR_TEXT);

    let  headers = {
      token: cookie.get('token')
    }

    let params = {
      note: addNumberComment,
      countryCode: countryCode
    };
    if(props.isMany === true){
      params['numbers'] = addNumbers;
    }else{
      params['number'] = addNumber;
    }

    props.setLoading(true);

    axios.post(props.apiUrl,
    params,
    {headers})
    .then(
      ({ data }) => {
        if(data.hasOwnProperty("responseStatus") && (data["responseStatus"] === API_OK 
        && data.hasOwnProperty("status") && (data['status'] === true))){
          if(props.isMany === true){
            setAddNumbers([]);
          }else{
            setAddNumber("");
          }
          setAddNumberComment("");
          setCountryCode("IL");
          props.setLoading(false);

          if(props.onResult){
            props.onResult({
              isMany: props.isMany === true,
              oks: (data.oks != null) ? data.oks : 1,
              errors: data.errors || {},
            });
            return;
          }

          if(props.isMany){
            if(data.errors && Object.keys(data.errors).length){
              let errString = "";
              for(const errKey in data.errors){
                if(data.errors.hasOwnProperty(errKey)){
                  errString = errString + errKey + ": " + data.errors[errKey] + ", ";
                }
              }
              errString = errString.substring(0, errString.length-2);
              props.setDetailedErrorMessageLocation(props.messageLocation);
              props.setDetailedErrorMessage(errString);
              props.setShowDetailedErrorMessage(true);
            }else{
              props.setSuccessMessageLocation(props.messageLocation);
              props.setShowSuccessMessage(true);
            }
          }else{
            props.setSuccessMessageLocation(props.messageLocation);
            props.setShowSuccessMessage(true);
          }
        }else{
          if((data.responseStatus === API_EXCEPTION) && (data.hasOwnProperty("message"))){
            errorMessage = data["message"];
          }
          props.setLoading(false);
          if(props.onError){ props.onError(errorMessage); }
          else { handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate); }
        }
      }).catch((error) => {
        props.setLoading(false);
        if(props.onError){ props.onError(errorMessage); }
        else { handleApiErrorMessage(errorMessage, t, dispatch, showErrorDialog, logout, navigate); }
    });
  };


  return ( 
      <div className='setting-wrapper'>
        <div className='item'>
          <div className='title strong'>{props.title}</div>
          <div className='content'>
            <div className='line'>
              {(
                props.isMany === true ?
                <>
                <div className='sub-title'>{t("Numbers to report:")}</div>
                {(
                  typeof props.note !== 'undefined' ? 
                  <div className='note'>{props.note}</div> : ''
                )}
                <div className='value'>
                  <textarea className="numbers"
                  value={addNumbers.join("\n")}
                  onChange={(e) => {
                    handleSetNumbers(e.target.value);
                    }}
                  />
                </div></> :
                <>
                <div className='sub-title'>{t("Number to report:")}</div>
                <div className='value'>
                  <TextField className="input" size="small" 
                  value={addNumber}
                  onChange={(e) => {
                    handleSetNumber(e.target.value);
                    }}
                  />
                </div></>
              )}
            </div>
            <div className='line'>
              <div className='title'>{t("Report comment:")}</div>
              {props.commentHint && <div className='note comment-hint'>{props.commentHint}</div>}
            
              <div className='value'>
                <TextField className="input" size="small"
                value={addNumberComment}
                onChange={(e) => {
                  setAddNumberComment(e.target.value);
                  }}
                />
              </div>
              </div>
            <div className='line'>
              <div className='title'>{t("Country code:")}</div>
              <div className='value'>
                <select
                  className="psh-select sn-country"
                  value={countryCode}
                  onChange={(e) => setCountryCode(e.target.value)}
                  id="search-country-code"
                >
                  {countryOptions.map((code) => (
                    <option key={code} value={code}>
                      {code}{DIAL_CODES[code] ? ` (+${DIAL_CODES[code]})` : ''}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {props.footer}
          </div>
          <Button
              variant="contained"
              color="primary"
              onClick={(e) => handleSubmitReportNumber()}
              className="agree"
          >
              {props.buttonTitle}
          </Button>
        </div>
      </div>
  );
}
